<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>工单管理</el-breadcrumb-item>
        <el-breadcrumb-item>服务器</el-breadcrumb-item>
        <el-breadcrumb-item>资源交付</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div>
      <el-radio-group v-model="tabPosition" style="margin-bottom: 20px" @change="handleTabChange">
        <el-radio-button label="3">搬迁</el-radio-button>
        <el-radio-button label="4">退役</el-radio-button>
        <el-radio-button label="2">TPC</el-radio-button>
        <el-radio-button label="5">直配</el-radio-button>
        <el-radio-button label="6">改造</el-radio-button>
      </el-radio-group>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="建单时间">
                <el-date-picker
                  v-model="searchForm.create_time"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单类型">
                <el-select clearable v-model="searchForm.order_level" placeholder="请选择">
                  <el-option
                    v-for="item in category_level_4Options[tabPosition]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="PO单号">
                <el-input v-model="searchForm.opTicketid" placeholder="请输入PO单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单单号">
                <el-input v-model="searchForm.ticket_id" placeholder="请输入工单工号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="区域-园区">
                <el-select clearable v-model="searchForm.campus" placeholder="请选择" @focus="handleSelectFocus">
                  <el-option
                    v-for="(item, index) in campusOptions"
                    :key="index"
                    :label="Object.values(item)[0]"
                    :value="Object.values(item)[0]"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单等级">
                <el-select clearable v-model="searchForm.SlALevel" placeholder="请选择">
                  <el-option label="重要的" value="0"></el-option>
                  <el-option label="一级" value="1"></el-option>
                  <el-option label="二级" value="2"></el-option>
                  <el-option label="三级" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处理人">
                <el-input v-model="searchForm.handle_user" placeholder="请输入处理人"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">资源交付列表</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <!-- <div class="status-indicators">
            <div class="status-indicator">
              <img src="@/assets/hd.png" class="status-light" />
              <span class="indicator-text">预超时</span>
            </div>
            <div class="status-indicator">
              <img src="@/assets/ld.png" class="status-light" />
              <span class="indicator-text">正常</span>
            </div>
          </div> -->
          <el-button @click="handleExport">催办</el-button>
          <el-button @click="handleExport">审计派单</el-button>
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table
          :data="faults"
          border
          stripe
          @selection-change="handleSelectionChange"
          ref="table"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column
            v-for="(column, index) in visibleColumns"
            :key="index"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :align="column.align"
            :fixed="column.fixed"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="column.prop === 'operation'">
                <el-button type="text" size="small" @click="handleViewDetail(scope.row)"
                  >查看详情</el-button
                >
              </span>
              <span v-else-if="column.prop === 'campus'">{{
                scope.row.campus === '张家口-怀来东园' ? '怀来-东园' : scope.row[column.prop] || '-'
              }}</span>
              <span v-else-if="column.prop === 'opTicketid'">
                <a
                  :href="
                    `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                  "
                  target="_blank"
                  >{{ scope.row.opTicketid }}</a
                >
              </span>
              <span v-else-if="column.prop === 'time_out'">
                <el-tag
                  :type="
                    scope.row.time_out === '已超时'
                      ? 'danger'
                      : scope.row.time_out === '未超时'
                      ? 'success'
                      : 'info'
                  "
                  size="small"
                >
                  {{ scope.row.time_out || '-' }}
                </el-tag>
              </span>
              <span v-else-if="column.prop === 'pre_time_out'">
                <div class="status-indicator">
                  <img
                    :src="require('@/assets/' + (scope.row.pre_time_out ? 'hd.png' : 'ld.png'))"
                    :class="['status-light', scope.row.pre_time_out ? 'breathing' : '']"
                  />
                  <span class="indicator-text">{{
                    scope.row.pre_time_out ? '预超时' : '正常'
                  }}</span>
                </div>
              </span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog
          title="设置显示项"
          :visible.sync="showColumnsDialog"
          :append-to-body="true"
          width="400px"
          :close-on-click-modal="false"
          custom-class="columns-dialog"
          :modal-append-to-body="false"
          :destroy-on-close="true"
        >
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox
              v-for="column in columns"
              :key="column.prop"
              :label="column.prop"
              class="checkbox-item"
            >
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getResourceDeliveryList, exportResourceList } from '@/api/workOrder';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import { getCampusList } from '@/api/operation';
export default {
  name: 'FaultList',
  data() {
    return {
      tabPosition: 1,
      showColumnsDialog: false,
      selectedColumns: [
        'ticket_id',
        'opTicketid',
        'serviceInfo',
        'category_level_4',
        'sla_level',
        'amount',
        'actualCount',
        'status',
        'handle_user',
        'campus',
        'time_out',
        'pre_time_out',
        'create_time',
        'operation',
      ],
      campusOptions: [], // 用于存储园区接口返回的数据
      hasLoaded: false, // 添加标志位防止重复加载
      defaultSelectedColumns: [
        'ticket_id',
        'opTicketid',
        'serviceInfo',
        'category_level_4',
        'sla_level',
        'amount',
        'actualCount',
        'status',
        'handle_user',
        'campus',
        'time_out',
        'pre_time_out',
        'create_time',
        'operation',
      ],
      columns: [
        { prop: 'ticket_id', label: '工单单号', width: 130 },
        { prop: 'opTicketid', label: 'PO单号', width: 130 },
        { prop: 'serviceInfo', label: '工单任务' },
        { prop: 'category_level_4', label: '工单类型', width: 80 },
        { prop: 'sla_level', label: '工单等级', width: 70 },
        { prop: 'amount', label: '设备数量', width: 70 },
        // { prop: 'actualCount', label: '实际数量', width: '100' },
        { prop: 'status', label: '状态', width: 80 },
        { prop: 'handle_user', label: '处理人', width: 100 },
        { prop: 'campus', label: '区域-园区', width: 80 },
        { prop: 'time_out', label: '是否超时', width: 80 },
        { prop: 'pre_time_out', label: '是否预超时', width: 100 },
        { prop: 'create_time', label: '建单时间', width: 150 },
        { prop: 'operation', label: '操作', align: 'center', fixed: 'right', width: 100 },
      ],
      visibleColumns: [],
      selectedRows: [],
      faults: [],
      searchForm: {
        create_time: [],
        start_time: '',
        end_time: '',
        order_level: undefined,
        SlALevel: '',
        ticket_id: '',
        opTicketid: '',
        serviceInfo: '',
        amount: '',
        status: '',
        handle_user: '',
        campus: '',
        time_out: '',
      },
      category_level_4Options: {
        1: [
          { value: 1, label: '≤2U上下架' },
          { value: 2, label: '>2U&≤8U上下架' },
          { value: 3, label: '>8U上下架' },
          { value: 4, label: 'GPU线缆连接' },
          { value: 5, label: 'GPU上下架' },
          { value: 6, label: '拔盘' },
          { value: 7, label: '服务器' },
          { value: 9, label: 'GPU位置确认(机架核验及上下架)' },
          { value: 13, label: '简单' },
          { value: 14, label: '普通' },
          { value: 15, label: '复杂' },
        ],
        2: [
          { value: 11, label: '服务器' },
          { value: 8, label: 'GPU' },
        ],
        3: [
          { value: 1, label: '≤2U上下架' },
          { value: 2, label: '>2U&≤8U上下架' },
          { value: 3, label: '>8U上下架' },
          { value: 4, label: 'GPU线缆连接' },
          { value: 5, label: 'GPU上下架' },
        ],
        4: [{ value: 6, label: '拨盘' }],
        5: [{ value: 9, label: '位置确认（机架核验及上下架）' }],
        6: [
          { value: 13, label: '简单' },
          { value: 14, label: '普通' },
          { value: 15, label: '复杂' },
        ],
      },
      // 删除未使用的computedCategoryOptions方法
      campusOptions: [
        { value: 'sh-lg', label: '上海-临港' },
        { value: 'sh-sy', label: '上海-书院' },
        { value: 'hz-dg', label: '杭州-东冠' },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.create_time = [
      this.$moment(startDate).format('YYYY-MM-DD'),
      this.$moment(endDate).format('YYYY-MM-DD'),
    ];
    this.handleDateChange(this.searchForm.create_time);
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    this.fetchFaultData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    //园区获取数据接口
    async getCampusData() {  
      try {
        const params = {
          spec_sign: 0,
        };
        const response = await getCampusList(params);
        if (response.data && response.data.code === 200) {
          this.campusOptions = response.data.data; 
          this.hasLoaded = true;
          //console.log("成功设置 campusOptions:", this.campusOptions)
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },
    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    handleDateChange(val) {
      if (val) {
        this.searchForm.start_time = val[0];
        this.searchForm.end_time = val[1] + ' 23:59:59';
      } else {
        this.searchForm.start_time = '';
        this.searchForm.end_time = '';
      }
    },
    fetchFaultData() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        category_level: Number(this.tabPosition),
        ...this.searchForm,
      };
      delete params.create_time;
      getResourceDeliveryList(params)
        .then((res) => {
          if (res.data.code === 200) {
            console.log(res.data);
            const list = res.data.data.list || [];
            this.faults = list.map((item) => {
              // 使用moment处理时间比较
              const olaTime = this.$moment(item.ola_time, 'YYYY-MM-DD HH:mm:ss'); // 规定的超时时间
              const currentTime = this.$moment(); // 当前时间
              const timeDiff = olaTime.diff(currentTime); // 与超时时间的时间差（毫秒）
              const fourHours = 4 * 60 * 60 * 1000; // 4小时的毫秒数
              // 如果已超时或距离超时不到4小时，都显示预超时状态
              item.pre_time_out = timeDiff <= fourHours;
              console.log('时间调试：', {
                ola_time: item.ola_time,
                ola_time_formatted: olaTime.format('YYYY-MM-DD HH:mm:ss'),
                current_time_formatted: currentTime.format('YYYY-MM-DD HH:mm:ss'),
                timeDiff,
                timeDiff_hours: Math.floor(timeDiff / (60 * 60 * 1000)),
                pre_time_out: item.pre_time_out,
              });
              return item;
            });
            this.total = res.data.data.total || 0;
          } else {
            this.$message.error(res.msg || '获取列表失败');
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error('获取列表失败:', err);
          this.$message.error('获取列表失败');
          this.loading = false;
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      this.searchForm = {
        create_time: [],
        start_time: '',
        end_time: '',
        order_level: undefined,
        SlALevel: '',
        ticket_id: '',
        opTicketid: '',
        serviceInfo: '',
        amount: '',
        status: '',
        handle_user: '',
        campus: '',
        ticketLevel: '',
        time_out: '',
      };

      this.tabPosition = '1';
      this.currentPage = 1;
      this.fetchFaultData();
    },
    async handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      this.loading = true;

      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          const params = {
            category_level: Number(this.tabPosition),
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([key, value]) =>
                  value !== '' && value !== null && value !== undefined && key !== 'create_time'
              )
            ),
          };

          const response = await exportResourceList(params);

          if (response.data) {
            const allData = response.data.data.list || [];
            // 转换数据格式
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.columns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (column.prop === 'create_time' && value) {
                    value = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
                  } else if (column.prop === 'campus' && value === '张家口-怀来东园') {
                    value = '怀来-东园';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            // 创建工作簿和工作表
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            // 设置列宽
            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '资源交付列表');

            // 生成文件名
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `资源交付列表_${timestamp}.xlsx`;

            // 导出文件
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          // 导出选中数据
          if (this.selectedRows.length === 0) {
            this.$message.warning('没有数据可导出');
            return;
          }

          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.columns.forEach((column) => {
              if (column.prop !== 'operation') {
                let value = row[column.prop];
                if (column.prop === 'create_time' && value) {
                  value = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
                } else if (column.prop === 'campus' && value === '张家口-怀来东园') {
                  value = '怀来-东园';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '资源交付列表');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `资源交付列表_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleTabChange() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleViewDetail(row) {
      window.open(
        `https://dcops.fre.tencent-cloud.com/appManage/tickets/details?params=${row.opTicketid}`,
        '_blank'
      );
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
};
</script>

<style scoped>
.status-indicators {
  display: inline-flex;
  align-items: center;
  gap: 16px;
}
.status-indicator {
  display: flex;
  align-items: center;
}
.status-light {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.status-light.breathing {
  animation: breathing 1.5s ease-in-out infinite;
}
@keyframes breathing {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.indicator-text {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}
</style>

<style scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 10px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.box-card {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button + .el-button {
  margin-left: 8px;
}
/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}
::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}
::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}
/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}
::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}
</style>
